import {LEGACY_TO_NEW_ROUTE_MAP} from './legacy-to-new-route-map'
import {normalizeNavPath} from './normalize-nav-path'

export function isMigratedLegacyPath(path: string) {
  const normalized = normalizeNavPath(path)
  return normalized in LEGACY_TO_NEW_ROUTE_MAP
}
